export default __webpack_public_path__ + "static/media/aviation-emissions-and-their-atmospheric-impacts.cf9aecb5.png";